import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { AppService } from '../services/app.service';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

/**
 * this intercepts all HttpClient errors, 
 * so all services should use "HttpClient" instead of "Http"
 *
 * @export
 * @class UnauthorizedAccessInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class UnauthorizedAccessInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(
        (err:any) => {
          if (err instanceof HttpErrorResponse) {            
            /// if status code is 401 or 403 redirect to sso page              
            if (err.status === 401 || err.status === 403) { 
              window.location.href = environment.endpointSSO.url;
            }
          }
   
          return throwError(err);
        })
    );

  }
}